import { IRawStyle } from "@fluentui/react";
import React from "react";
import { useParams } from "react-router-dom";
import { Badge, BadgeColor } from "sprint-common-web";

import { Notes } from "../../../../../common/components/notes/Notes";
import { NoteSubjectType } from "../../../../../common/types/NoteSubjectType";
import { SprintAccessRight } from "../../../../../core/security/SprintAccessRight";

export interface FileRecordNotesSectionProps {
    style?: IRawStyle;
}

export const FileRecordNotesSection = ({ style }: FileRecordNotesSectionProps): JSX.Element => {
    const { fileRecordId } = useParams<{ fileRecordId: string }>();

    return (
        <Notes
            subjectType={NoteSubjectType.FileRecord}
            subjectId={fileRecordId}
            sourceIds={[fileRecordId]}
            style={style}
            isInlineCreateSupported={true}
            isDeleteSupported={true}
            accessRights={[SprintAccessRight.CiReadWrite]}
            renderBadge={() => (
                <Badge
                    text="On-Prem"
                    color={BadgeColor.Blue}
                    size={12}
                    testId="note-on-prem-badge"
                    tooltipContent="File record note"
                />
            )}
        />
    );
};
